import { transformUnits } from '@/helpers/unit-formatter/unit-formatter';
import { FormattedUnitLabels, UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import {
  formatNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/unit-formatter.utils';

/**
 * Default formatter for unit values.
 * Transforms the unit value to the specified display units and formats it
 * with proper spacing between value and units.
 *
 * @param {UnitValue} unitValue - The value and units to format
 * @param {any} unitValue.value - The numeric or string value to format
 * @param {string} [unitValue.units] - The current units of the value
 * @param {string} [displayUnits] - Optional target units to transform to before formatting
 * @returns {FormattedUnitLabels} Formatted labels containing:
 *   - valueLabel: The formatted numeric value
 *   - unitsLabel: The unit string
 *   - valueUnitsLabel: Combined value and units with proper spacing
 *
 * @example
 * formatDefault({ value: 100, units: '°F' }, '°C')
 * // Returns: { valueLabel: '37.78', unitsLabel: '°C', valueUnitsLabel: '37.78 °C' }
 */
export const formatDefault = (unitValue: UnitValue, displayUnits?: string): FormattedUnitLabels => {
  const transformed = transformUnits(unitValue, displayUnits);

  return unitValueToFormattedUnitLabels({
    value: formatNumber(transformed.value),
    units: transformed.units,
  });
};
